export default __webpack_public_path__ + "static/media/logo.69d1fe2c.png";